const BROWSER_MATCHERS: readonly (readonly [RegExp, string])[] = [
  [/Edg\//, 'Edge'],
  [/OPR\/|Opera/, 'Opera'],
  [/Chrome\//, 'Chrome'],
  [/Firefox\//, 'Firefox'],
  [/Safari\//, 'Safari']
] as const;

const OS_MATCHERS: readonly (readonly [RegExp, string])[] = [
  [/Windows/, 'Windows'],
  [/iPhone|iPad|iPod/, 'iOS'],
  [/Mac OS X|Macintosh/, 'macOS'],
  [/Android/, 'Android'],
  [/Linux|X11/, 'Linux']
] as const;

const findLabel = (
  matchers: readonly (readonly [RegExp, string])[],
  userAgent: string
): string | undefined =>
  matchers.find(([pattern]) => pattern.test(userAgent))?.[1];

const getDeviceName = (userAgent: string): string => {
  const browser = findLabel(BROWSER_MATCHERS, userAgent);
  const os = findLabel(OS_MATCHERS, userAgent);
  return browser && os ? `${browser} on ${os}` : 'this device';
};

export default getDeviceName;
